import { create } from "zustand";
import { LoginDto } from "../Models/Types";
import { Profile } from "../Models/Profile";
import { getProfile } from "../repositories/UserRepository";

export interface UserStore {
  user?: Profile;
  fetchProfile: (loginData: LoginDto) => Promise<number | undefined>;
}

export const useProfile = create<UserStore>((set) => ({
  fetchProfile: (loginData: LoginDto) => {
    return getProfile(set, loginData);
  },
}));
